export const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  // the default value for minimumFractionDigits depends on the currency and is usually already 2
});

currencyFormatter.parse = function(s) {
  s = s.trim();
  if (s.startsWith('$'))
    s = s.slice(1);
  s = s.replace(/\,/g,'');
  return parseFloat(s);
}

export function isValidDate(d) {
  return d instanceof Date && !isNaN(d);
}

export function toDate(date) {
  return typeof(date)=='string' ? new Date(date) : date;
}

export function formatShortDate(date) {
  return (date instanceof Date) ? `${date.getUTCFullYear()}-${date.getUTCMonth()+1}-${date.getUTCDate()}` : date;
}

export function formatPrintDate(date) {
  return (date instanceof Date) ? `${date.getUTCMonth()+1}/${date.getUTCDate()}/${date.getUTCFullYear()}` : date;
}

export function formatLongDate(date) {
  let monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

  let day = date.getDate();
  let monthIndex = date.getMonth();
  let year = date.getFullYear();

  return day + ' ' + monthNames[monthIndex] + ' ' + year;
}

export function getParameterByName(name) {
  let match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
  return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}

function float2int(value) {
  return value | 0;
}

export function setTimer(timeout, func) {
  setTimeout(func, timeout);
}

export function saveAsFile(filename, data) {
    let blob = new Blob([data], {type: 'application/json'});
    if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveBlob(blob, filename);
    }
    else{
        let elem = window.document.createElement('a');
        elem.href = window.URL.createObjectURL(blob);
        elem.download = filename;
        document.body.appendChild(elem);
        elem.click();
        document.body.removeChild(elem);
    }
}

export function copyToClipboard(text) {
  if (navigator.clipboard) {
    // This only works with https:
    navigator.clipboard.writeText(text).catch(err => {
      console.log("copyToClipboard(): navigator.clipboard didn't work", err);
    });
  }
  else {
    // This doesn't work:
    setTimer(500, () => {
      let tempInput = document.createElement("textarea");
      tempInput.style = "position: absolute; left: -1000px; top: -1000px";
      tempInput.value = text;
      document.body.appendChild(tempInput);
      tempInput.select();
      document.execCommand("copy");
      document.body.removeChild(tempInput);
    });
  }
}

export function sendMail(to, subject, body) {
  let link = `mailto:${encodeURIComponent(to)}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  window.open(link/*, "_blank"*/);
  // window.focus();
  // let elem = window.document.createElement('a');
  // elem.href = link;
  // document.body.appendChild(elem);
  // elem.click();
  // document.body.removeChild(elem);
}
